<template>
  <div>
    <div v-if="filtering" class="spinner-area">
      <b-spinner class="spinner-border text-custom-blue" />
    </div>

    <section v-else class="list-vacinacao">
      <b-table
        id="tableVacinacao"
        ref="tableVacinacao"
        responsive
        :stickyColumn="true"
        :fields="fields"
        :items="items"
        :sort-by.sync="localSortBy"
        :sort-desc.sync="localSortDesc"
        @sort-changed="$emit('sort-changed', $event)"
        no-local-sorting
        :no-sort-reset="true"
        :tbody-tr-attr="hasCns"
        show-empty
      >
      <template #head(id_pessoa_fisica)>
        <b-form-checkbox v-model="localSelectAll" @change="$emit('toggle-select-all', localSelectAll)" />
      </template>

      <template #cell(id_pessoa_fisica)="row">
        <b-form-checkbox v-model="row.item.selected" :disabled="row.item.situacao !== 'Erro'" />
      </template>

      <template #cell(dr)="row">
        <span class="font-weight-bold comprimento_maximo_celulas" v-b-tooltip :title="tooltipText(row.item.sigla_departamento)">
          {{ row.item.sigla_departamento }}
        </span>
      </template>

      <template #cell(empresa)="row">
        <div class="d-flex flex-column">
          <span class="font-weight-bold comprimento_maximo_celulas" v-b-tooltip :title="tooltipText(row.item.razao_social)">
            {{ row.item.razao_social }}
          </span>
          <span class="font-weight-bold comprimento_maximo_celulas" v-b-tooltip :title="tooltipText(row.item.nome_fantasia)">
            {{ row.item.nome_fantasia }}
          </span>
          <span class="comprimento_maximo_celulas">{{ row.item.cnpj | formataCpfCnpj }}</span>
        </div>
      </template>

      <template #cell(colaborador)="row">
        <div class="d-flex flex-column">
          <span class="font-weight-bold comprimento_maximo_celulas" v-b-tooltip :title="tooltipText(row.item.pessoa_fisica_nome)">
            {{ row.item.pessoa_fisica_nome }}
          </span>
          <span class="comprimento_maximo_celulas">{{ row.item.cpf | formataCpfCnpj }}</span>
        </div>
      </template>

      <template #cell(data_vacinacao)="row">
        <span class="font-weight-bold comprimento_maximo_celulas">{{ formatarData(row.item.data) }}</span>
      </template>

      <template #cell(tipo_acao)="row">
        <span class="font-weight-bold comprimento_maximo_celulas">{{ row.item.tipo_de_acao }}</span>
      </template>

      <template #cell(inconsistencias)="row">
        <div v-if="getParsedInconsistencias(row.item.inconsistencias).length > 0">
          <span class="font-size-0-85rem">{{ getUltimaInconsistencia(row.item.inconsistencias) }}</span>
        </div>
        <span v-else class="text-muted">N/A</span>
      </template>

      <template #cell(acoes)="row">
        <b-dropdown variant="link" no-caret right :boundary="'viewport'" :flip="true" :offset="'0,5'">
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="text-secondary" />
          </template>
          <b-dropdown-item v-if="row.item.id_integracao" @click="$emit('visualizar-inconsistencias', row.item)">
            <feather-icon icon="EyeIcon" size="14" class="mr-50" />Visualizar Inconsistências
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('historico-reprocessamento', row.item)">
            <feather-icon icon="ClockIcon" size="14" class="mr-50" />Histórico de Reprocessamento
          </b-dropdown-item>
          <b-dropdown-item v-if="row.item.situacao === 'Erro'" @click="$emit('reprocessar', row.item)">
            <feather-icon icon="RefreshCwIcon" size="14" class="mr-50" />Reprocessar
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="$emit('download-json', row.item)">
            <feather-icon icon="DownloadIcon" size="14" class="mr-50" />Download TXT/JSON
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <template #empty>
        <div class="text-center py-4">
          <span>Nenhum colaborador encontrado.</span>
        </div>
      </template>
    </b-table>

      <div class="pb-2 px-1">
        <b-col sm="12" class="mt-2">
          <CustomPagination :paginacao="paginationData" @page-cliked="$emit('page-change', $event)" />
        </b-col>
      </div>
    </section>
  </div>
</template>

<script>
import { BTable, BFormCheckbox, BDropdown, BDropdownItem, BDropdownDivider, BCol, BSpinner } from 'bootstrap-vue';
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue';
import moment from 'moment';

export default {
  name: 'IntegracaoRndsTabela',
  components: {
    BTable, BFormCheckbox, BDropdown, BDropdownItem, BDropdownDivider, BCol, BSpinner, CustomPagination
  },
  props: {
    items: { type: Array, default: () => [] },
    filtering: { type: Boolean, default: false },
    paginationData: { type: Object, required: true },
    selectAll: { type: Boolean, default: false },
    sortBy: { type: String, default: '' },
    sortDesc: { type: Boolean, default: false }
  },
  data() {
    return {
      lengthColumnMaximo: 27,
      fields: [
        { key: 'id_pessoa_fisica', label: '', sortable: false, class: 'align-middle mxw-15 pr-2' },
        { key: 'dr', label: 'DR', sortable: true, class: 'align-middle mw-50' },
        { key: 'unidade', label: 'UNIDADE OPERACIONAL', sortable: true, class: 'align-middle mw-200' },
        { key: 'empresa', label: 'EMPRESA', sortable: true, class: 'align-middle mw-200' },
        { key: 'colaborador', label: 'NOME | CPF', sortable: false, class: 'align-middle mw-50' },
        { key: 'vacina', label: 'VACINA', sortable: false, class: 'align-middle mw-100' },
        { key: 'dose', label: 'DOSE', sortable: false, class: 'align-middle mw-100' },
        { key: 'campanha', label: 'CAMPANHA', sortable: false, class: 'align-middle mw-100' },
        { key: 'data_vacinacao', label: 'DATA DA VACINACAO', sortable: false, class: 'align-middle mw-50' },
        { key: 'tipo_acao', label: 'TIPO DE AÇÃO', sortable: false, class: 'align-middle mw-50' },
        { key: 'situacao', label: 'SITUAÇÃO DO ENVIO', sortable: false, class: 'align-middle mw-50' },
        { key: 'inconsistencias', label: 'INCONSISTÊNCIAS', sortable: false, class: 'align-middle mw-50' },
        { key: 'acoes', label: 'AÇÕES', sortable: false, class: 'align-middle mw-50' }
      ]
    };
  },
  computed: {
    localSelectAll: {
      get() { return this.selectAll; },
      set(val) { this.$emit('update:selectAll', val); }
    },
    localSortBy: {
      get() { return this.sortBy; },
      set(val) { this.$emit('update:sortBy', val); }
    },
    localSortDesc: {
      get() { return this.sortDesc; },
      set(val) { this.$emit('update:sortDesc', val); }
    }
  },
  methods: {
    hasCns(item) {
      if (item && item.vacinador_possui_cns === false) {
        return { style: 'background-color: rgba(234, 84, 85, 0.12)' };
      }
      return {};
    },
    tooltipText(text) {
      return text && text.length > this.lengthColumnMaximo ? text : null;
    },
    formatarData(data) {
      if (!data) return '-';
      const formatted = moment(data).format('DD/MM/YYYY');
      return formatted === 'Invalid date' ? data : formatted;
    },
    getParsedInconsistencias(inconsistencias) {
      if (!inconsistencias) return [];
      try {
        if (Array.isArray(inconsistencias)) return inconsistencias;
        if (typeof inconsistencias === 'string') return JSON.parse(inconsistencias);
        return [];
      } catch { return []; }
    },
    getUltimaInconsistencia(inconsistencias) {
      const parsed = this.getParsedInconsistencias(inconsistencias);
      if (parsed.length === 0) return '';
      return parsed[parsed.length - 1].descricao;
    }
  }
};
</script>

<style scoped>
.comprimento_maximo_celulas {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}
.font-size-0-85rem {
  font-size: 0.85rem;
}
.spinner-area {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>
